import styled, { css } from 'styled-components';

export const SidebarTooltip = styled.span`
  position: fixed;
  display: block;
  font-size: 14px;
  line-height: 18px;
  background: var(--blue);
  color: var(--white);
  padding: 5px 10px;
  border-radius: 5px;
  white-space: nowrap;
  opacity: ${props => (props.$visible ? 1 : 0)};
  visibility: ${props => (props.$visible ? 'visible' : 'hidden')};
  transition: opacity 0.3s ease, visibility 0.3s ease, transform 0.3s ease;
  transform: ${props => (props.$visible ? 'translate(0, -50%)' : 'translate(8px, -50%)')};
  z-index: 999;
  pointer-events: none;

  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: -10px;
    transform: translateY(-50%);
    width: 0;
    height: 0;
    border-top: 5px solid transparent;
    border-right: 10px solid var(--blue);
    border-bottom: 5px solid transparent;
  }
`;

export const StyledSideBar = styled.div`
  background: var(--white);
  padding: 15px 0 0 0;
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  max-width: ${({ $sideBar }) => ($sideBar ? '230px' : '62px')};
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
  color: var(--white);
  z-index: ${({ $creditsOpen }) => ($creditsOpen ? 150 : 70)};
  border-right: 1px solid #e6e7ec;
  flex-shrink: 0;
  transition: max-width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
  
  @media (min-width: 1450px) {
    max-width: ${({ $sideBar }) => ($sideBar ? '290px' : '85px')};
    padding: 20px 0 0 0;
  }

  @media (max-width: 991px) {
    left: 0;
    bottom: 0;
    max-width: 290px;
    transform: translateX(-200%);
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;

    .aside-active & {
      transform: translateX(0%);
    }
  }

  @media (max-width: 576px) {
    max-width: 260px;
  }

  .sidebar-header {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
    padding: 0 10px;
    box-sizing: border-box;
    @media (min-width: 1450px) {
      padding: 0 20px;
    }
  }

  .collapse-btn {
    position: relative;
    display: flex;
    align-items: center;
    gap: ${({ $sideBar }) => ($sideBar ? '6px' : '0')};
    width: 100%;
    padding: 6px 10px;
    padding-left: ${({ $sideBar }) => ($sideBar ? '10px' : 'calc(50% - 9px)')};
    border: none;
    background: none;
    border-radius: 10px;
    box-sizing: border-box;
    cursor: pointer;
    font-size: 14px;
    line-height: 20px;
    font-weight: 400;
    font-family: inherit;
    color: #83899f;
    transition:
      background 0.2s ease-in-out,
      padding-left 0.3s ease-in-out,
      gap 0.3s ease-in-out;

    .arrow-wrap {
      position: relative;
      flex-shrink: 0;
      width: 18px;
      height: 18px;
    }

    .arrow-icon {
      position: absolute;
      top: 0;
      left: 0;
      font-size: 18px;
      color: #7aacf0;
      transition:
        color 0.2s ease-in-out,
        opacity 0.25s ease-in-out;
    }

    .arrow-left {
      opacity: ${({ $sideBar }) => ($sideBar ? 1 : 0)};
    }

    .arrow-right {
      opacity: ${({ $sideBar }) => ($sideBar ? 0 : 1)};
    }

    .collapse-label {
      max-width: ${({ $sideBar }) => ($sideBar ? '80px' : '0')};
      opacity: ${({ $sideBar }) => ($sideBar ? 1 : 0)};
      overflow: hidden;
      white-space: nowrap;
      color: #83899f;
      transition:
        max-width 0.3s ease-in-out,
        opacity 0.25s ease-in-out,
        color 0.2s ease-in-out;
    }

    .tooltip {
      position: fixed;
      left: 74px;
      display: block;
      font-size: 14px;
      line-height: 18px;
      background: var(--blue);
      color: var(--white);
      padding: 5px 10px;
      border-radius: 5px;
      white-space: nowrap;
      opacity: 0;
      visibility: hidden;
      transition: 0.3s;
      transform: translateX(10px);
      z-index: 999;

      &::before {
        content: '';
        position: absolute;
        top: 50%;
        left: -10px;
        transform: translateY(-50%);
        width: 0;
        height: 0;
        border-top: 5px solid transparent;
        border-right: 10px solid var(--blue);
        border-bottom: 5px solid transparent;
      }

      ${({ $sideBar }) =>
    $sideBar &&
    css`
          display: none !important;
        `}
    }

    ${({ $sideBar }) =>
    $sideBar
      ? css`
            &:hover {
              background: rgba(39, 131, 236, 0.08);

              .arrow-icon,
              .collapse-label {
                color: var(--blue);
              }
            }
          `
      : css`
            &:hover {
              background: rgba(39, 131, 236, 0.08);

              .arrow-icon {
                color: var(--blue);
              }

              .tooltip {
                visibility: visible;
                opacity: 1;
                transform: translateX(0);
              }
            }
          `}
  }

  ${({ $sideBar }) =>
    $sideBar &&
    css`
      .nav-links {
        li {
          a,
          button {
            .tooltip {
              display: none !important;
            }
            .label {
              white-space: nowrap;
              color: #4C6484;
              font-weight: 500;
            }
          }
          button.logout {
            .label {
              color: #ffa2a4;
            }
            .tooltip {
              display: none !important;
            }
          }
        }
      }
    `}

  .logoWrapper {
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    z-index: 3;

    .logo-link {
      position: relative;
      display: block;
      height: 50px;
      width: ${({ $sideBar }) => ($sideBar ? '170px' : '45px')};
      margin-left: ${({ $sideBar }) => ($sideBar ? '0' : 'calc((100% - 50px) / 2)')};
      overflow: hidden;
      will-change: width, margin-left;
      transition:
        width 0.3s cubic-bezier(0.4, 0, 0.2, 1),
        margin-left 0.3s cubic-bezier(0.4, 0, 0.2, 1);

        @media (min-width: 1450px) {
          width: ${({ $sideBar }) => ($sideBar ? '180px' : '45px')};
        }
    }

    .logo-lg,
    .logo-sm {
      position: absolute;
      top: 50%;
      display: block;
      height: auto;
      transform: translateY(-50%);
    }

    .logo-lg {
      left: 0;
      width: 200px;
      opacity: ${({ $sideBar }) => ($sideBar ? 1 : 0)};
      visibility: ${({ $sideBar }) => ($sideBar ? 'visible' : 'hidden')};
      transform: translateY(-50%)
        translateX(${({ $sideBar }) => ($sideBar ? '0' : '-12px')});
      transition:
        opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1)
          ${({ $sideBar }) => ($sideBar ? '0.1s' : '0s')},
        visibility 0.3s cubic-bezier(0.4, 0, 0.2, 1)
          ${({ $sideBar }) => ($sideBar ? '0.1s' : '0s')},
        transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    }

    .logo-sm {
      left: 50%;
      width: 50px;
      opacity: ${({ $sideBar }) => ($sideBar ? 0 : 1)};
      visibility: ${({ $sideBar }) => ($sideBar ? 'hidden' : 'visible')};
      transform: translate(-50%, -50%)
        scale(${({ $sideBar }) => ($sideBar ? '0.85' : '1')});
      transition:
        opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1)
          ${({ $sideBar }) => ($sideBar ? '0s' : '0.1s')},
        visibility 0.3s cubic-bezier(0.4, 0, 0.2, 1)
          ${({ $sideBar }) => ($sideBar ? '0s' : '0.1s')},
        transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    }
  }
  .time-web-box {
    width: 100%;
    padding: 10px 18px;
  }

  .timeweb {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px;
    gap: 14px;
    width: 40px;
    height: 40px;
    margin: 0 auto;
    border-radius: 50px;
    border: 1px solid #e6e7ec;
    background: var(--white);
    transition: all ease-in-out 0.3s;

    .aside-active & {
      width: 100%;
      margin: 0;
      padding-left: 40px;

      .title,
      .select-box {
        width: auto;
        opacity: 1;
        overflow: visible;
        visibility: visible;
        transition-delay: 0.2s;
      }
    }

    .img-box {
      position: absolute;
      top: 7px;
      left: 7px;
      flex-shrink: 0;
      width: 24px;
      height: 24px;
      overflow: hidden;
      cursor: pointer;

      img {
        display: block;
        width: 100%;
        height: auto;
      }
    }

    .title {
      display: block;
      font-size: 16px;
      line-height: 20px;
      font-weight: 600;
      color: #0a1b39;
      opacity: 0;
      width: 0;
      overflow: hidden;
      visibility: hidden;
      transition: all ease-in-out 0.3s;
    }

    .select-box {
      position: relative;
      flex-grow: 1;
      font-size: 12px;
      line-height: 15px;
      color: #83899f;
      padding-right: 28px;
      cursor: pointer;
      opacity: 0;
      visibility: hidden;
      transition: all ease-in-out 0.3s;

      .icon {
        position: absolute;
        top: 6px;
        right: 10px;
      }

      .select-drop {
        list-style: none;
        margin: 0;
        padding: 0;
        position: absolute;
        top: 100%;
        right: 15px;
        padding: 5px 0;
        margin-top: 11px;
        width: 140px;
        border: 1px solid #e6e7ec;
        border-radius: 0 0 10px 10px;
        background: var(--white);
        z-index: 2;

        li {
          padding: 5px 10px;
          cursor: pointer;

          &:hover {
            background: #f5f5f5;
          }
        }
      }
    }
  }

  .sidebar-tooltip-anchor {
    position: absolute;
    right: 0;
    top: 50%;
    width: 0;
    height: 0;
    overflow: visible;
    pointer-events: none;
  }

  .nav-wrapper {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    width: 100%;
    min-height: 0;
    overflow: hidden;

    .nav-scroll {
      display: flex;
      flex-direction: column;
      flex: 1 1 auto;
      min-height: 0;
      overflow-y: auto;
      overflow-x: hidden;
      scroll-behavior: smooth;

      &::-webkit-scrollbar {
        width: 0;
      }

      .navigation {
        flex-grow: 1;
      }
    }

    .subheading {
      display: block;
      font-size: 14px;
      line-height: 16px;
      color: #83899F;
      width: 100%;
      padding: 8px 0 8px 12px;
      transition: color 0.3s ease-in-out, padding 0.3s ease-in-out;
      white-space: nowrap;
      box-sizing: border-box;

      @media (min-width: 1450px) {
        padding: 8px 0 8px 26px;
      }

      
      &.is-collapsed {
        color: transparent;
        padding-left: 0;
        padding-right: 0;
        user-select: none;
        pointer-events: none;
      }
      
      @media (min-width: 992px) {
        
        
        ${({ $sideBar }) =>
    $sideBar &&
    css`
            display: block;
            width: 100%;
          `}
      }
    }

    .nav-links {
      padding: 0 0 10px;

      li {
        padding: 0 10px ;
        position: relative;
        width: 100%;
        text-align: left;
        @media (min-width: 1450px) {
          padding: 0 20px;
        }

        &:not(:last-child) {
          margin: 0 0 5px;
        }

        a,
        button {
          position: relative;
          width: 100%;
          min-height: 34px;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          gap: 7px;
          overflow: hidden;
          padding: 7px 10px;
          border-radius: 12px;
          text-decoration: none;
          
          @media (min-width: 1450px) {
            gap: 12px;
          }

          &:hover,
          &.active {
            background: rgba(39, 131, 236, 0.05);

            .label,
            .icon {
              transition: 0.3s;
              filter: invert(37%) sepia(96%) saturate(1613%) hue-rotate(196deg) brightness(97%) contrast(90%);
            }
          }

          .label {
            display: block;
            flex-shrink: 0;
            font-size: 12px;
            line-height: 16px;
            transition: 0.3s;
            text-align: left;
            transform: translateX(10px);

            @media (min-width: 1450px) {
              font-size: 14px;
              line-height: 20px;
              
            }

            .aside-active & {
              transform: translateX(0);
            }
          }

          .sub {
            flex-grow: 1;
          }

          .free-tag {
            font-size: 12px;
            line-height: 16px;
            padding: 3px 12px;
            border-radius: 50px;
            color: var(--blue);
            background: rgba(39, 131, 236, 0.1);
          }
        }

        .icon {
          width: 17px;
          height: 17px;
          flex-shrink: 0;
          margin-left: 2px;
          @media (min-width: 1450px) {
            width: 20px;
            height: 20px;

          }
        }

        &.active::before {
          position: absolute;
          content: '';
          top: 0;
          bottom: 0;
          left: 0;
          width: 5px;
          background: var(--blue);
          border-radius: 0 50px 50px 0;
        }
      }
    }

    .help-center {
      display: flex;
      align-items: center;
      gap: 10px;
      padding: 13px 20px;
      position: relative;
      flex-shrink: 0;
      transition: all ease-in-out 0.3s;
      background: #fafafa;
      border-top: 1px solid #e6e7ec;

      .icon-arrow {
        position: absolute;
        right: -50px;
        top: 50%;
        transform: translateY(-50%);
        font-size: 25px;
        color: #9ca0b2;
      }

      .img-box {
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        width:  28px;
        height: 28px;
        border-radius: 50px;
        background: var(--white);
        box-shadow: 0px 6px 16px 0px rgba(89, 108, 148, 0.3);

        img{
width: 22px;
height: 22px;
        }
      }

      .label {
        width: 100%;
        display: none;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-size: 15px;
        line-height: 18px;
        font-weight: 500;
        color: #4C6484;
      }

      ${({ $sideBar }) =>
    $sideBar &&
    css`
          padding: 13px 30px;

          .label {
            display: block;
          }
          .icon-arrow {
            right: 20px;
          }
        `}
    }
  }

  .profile {
    position: relative;
    width: 100%;
    /* max-width: 30px; */
    padding: 0;
    z-index: 3;
    margin: 0 auto;

    ${({ $sideBar }) =>
    $sideBar &&
    css`
        /* max-width: 240px; */
        padding: 10px 0 0;

        .profile-text {
          /* max-width: 217px; */
          /* margin: 0 0 12px; */
 
          .body {
            display: flex;
          }
        }
      `};
  }

  .profile-text {
    position: relative;
    display: flex;
    align-items: center;
    gap: 6px;
    /* max-width: 50px; */
    width: 100%;
    transition: 0.3s;
    @media (max-width: 576px) {
      max-width: 100%;
    }

    .pic {
      width: 30px;
      height: 30px;
      border-radius: 50px;
      overflow: hidden;
      flex-shrink: 0;
      position: relative;
      cursor: pointer;
      &:before {
        content: '';
        position: absolute;
        inset: 0;
        background: rgba(0, 0, 0, 0.2);
        opacity: 0;
        transition: 0.5s;
      }

      &:hover {
        &:before {
          opacity: 1;
        }
        .arrow-icon {
          opacity: 1;
          margin: 0;
        }
      }

      .arrow-icon {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%) rotate(50deg);
        margin: 30px 0px 0 -30px;
        transition: 0.3s;
      }

      img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .body {
      display: none;
      flex-direction: column;
      color: var(--primary);

      .greeting {
        font-size: 13px;
        font-weight: 400;
        line-height: 15px;
      }

      .name,
      .email {
        width: 171px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }

      .name {
        font-size: 15px;
        line-height: 18px;
        font-weight: 500;
      }

      .email {
        font-size: 12px;
        line-height: 16px;
      }
    }
  }

  .circle {
    display: none;
  }

`;
